// mutations
const ACADEMIC_ATTENDANT_ALL = (state, academicAttendant) => {
    if (academicAttendant.code === 1) {
      state.academicAttendant = academicAttendant.data
      state.status = 'success'
    } else {
      alert(academicAttendant.message)
      state.status = 'error'
    }
  }
  
  export default {
    ACADEMIC_ATTENDANT_ALL
  }
  


// WEBPACK FOOTER //
// ./src/store/modules/academic/attendant/mutations.js